'use client'

import Image from 'next/image'
import { cn } from '@/lib/utils'

interface ThemeLogoProps {
  className?: string
  width?: number
  height?: number
}

export function ThemeLogo({ className, width = 20, height }: ThemeLogoProps) {
  // Original SVG dimensions: 311x504 (vertically rectangular).
  // The height attribute must be an integer: a fractional value can never
  // equal the browser's rounded layout height, so next/image's dev check
  // reads it as "height modified but not width" and warns on every load.
  const aspectRatio = 311 / 504 // width/height = ~0.617
  const calculatedHeight = height || Math.round(width / aspectRatio)

  return (
    <>
      {/* Light theme logo */}
      <Image
        src="/logo_light.svg"
        alt="Euclideum Logo"
        width={width}
        height={calculatedHeight}
        className={cn(className, 'dark:hidden')}
        style={{ width: `${width}px`, height: 'auto' }}
        priority
      />
      {/* Dark theme logo */}
      <Image
        src="/logo_dark.svg"
        alt="Euclideum Logo"
        width={width}
        height={calculatedHeight}
        className={cn(className, 'hidden dark:block')}
        style={{ width: `${width}px`, height: 'auto' }}
        priority
      />
    </>
  )
}
